export const baseEnv = {
  domain: {
    stage: 'sagetechnologypartners.com',
    prod: 'seinterminal.com',
    dev: 'lvh.me',
  },
};
